<template>
    <div class="posts_root_div">
        <MainPosts class="main_posts"></MainPosts>
        <Side class="side_questions"></Side>
    </div>
</template>

<script type="text/javascript">
import MainPosts from './sub_components/main_posts.vue'
import Side from './sub_components/side.vue'

export default {
    components: {
        MainPosts,
        Side
    }
}

</script>
<style type="text/css" scoped>
.posts_root_div {
    width: 1170px;
    margin-left: auto;
    margin-right: auto;
    padding: 0 5px;
    display: flex;
}

.main_posts {
    width: 75%;
}

.side_questions {
    width: 25%;
}
</style>
